// this is a browser-only module. There is a non-browser equivalent in the same
// directory. This is done using a `package.json` browser field.
// old-IE fallback logic: http://stackoverflow.com/a/10260692
module.exports =  !!document.attachEvent && window !== document.parentWindow;



//////////////////
// WEBPACK FOOTER
// ../node_modules/get-window/needs-ie-fallback.br.js
// module id = 1095
// module chunks = 0